(function ($) {
  'use strict';

  console.log('product-swatch.js loaded');
  // Product image swatch: update card link + main image
  $(document).on('click', '.TopProductItem_swatches .TopProductItem_swatchBtn', function (e) {
    e.preventDefault();

    var $btn = $(this);
    if ($btn.hasClass('is-disabled')) return;

    var $root = $btn.closest('[data-product-swatch-root]');
    if (!$root.length) $root = $btn.parents('.TopProductItem, .gridProductItem').first();

    var url = $btn.data('variant-url');
    var img = $btn.data('variant-image');
    var title = $btn.data('variant-title');

    if (url) {
      $root.find('a.TopProductItem_link').first().attr('href', url);
    }

    if (img) {
      var $imgEl = $root.find('img.TopProductItem_imageImg').first();
      if ($imgEl.length) {
        // Some cards (e.g. product-grid-item) use lazysizes and srcset/data-srcset.
        // Keep all relevant attributes in sync so the swapped image is not overwritten.
        $imgEl.attr('src', img);
        $imgEl.attr('data-src', img);
        $imgEl.attr('srcset', img);
        $imgEl.attr('data-srcset', img);
        $imgEl.removeAttr('data-widths');
        $imgEl.removeAttr('sizes');
        $imgEl.attr('data-sizes', 'auto');
        if (title) $imgEl.attr('alt', title);
      }
    }

    $btn.closest('.TopProductItem_swatches').find('.TopProductItem_swatchBtn').removeClass('is-active');
    $btn.addClass('is-active');
  });
})(window.jQuery);

